import { truncate } from "lodash";

export const programTitleTickFormatter = (val: string) => {
  const lastDashIndex = val.lastIndexOf(" - ");
  const programTitle = val.substring(0, lastDashIndex);
  return truncate(programTitle, { length: 25 });
};
